module.exports = __webpack_public_path__ + "static/media/31JFA1.16107f7c.jpg";